import React from 'react';

import './maisInformacoes.css';

const MaisInformacoes = () => {
    return (
        <div className="main-div">
            <p><p>Os direitos sexuais constituem-se como o direito a viver a sexualidade
            com prazer, o direito à liberdade e autonomia no exercício responsável. Isso implica viver a
            sexualidade livre de coerção, discriminação e violência. Ou seja, as pessoas têm o direito de se
            relacionarem e decidirem quando e de que forma se relacionarem.
            E baseia-se em quatro princípios éticos:
            Integridade Corporal: O cuidado com o corpo físico e com a manutenção do corpo.
            Autonomia pessoal: Autodeterminação, ser visto como sujeito de direitos e capaz;
            Igualdade: Gênero, Geração, Cor da pele;
            Diversidade: Individualidades devem ser respeitadas; População LGBT+</p></p>





        </div>
    )
}

export default MaisInformacoes;